






























import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import { Controlador as Model, ControladorDeCurso } from '../curso-controlador';
import preguntas from './curso-resultado-preguntas.vue';
import { Recurso } from '@/__env/lib/Cursos/Recursos';
import { Wait } from '@/__env/ext';
import { Pregunta } from '@/__env/lib/Cursos/Preguntas';
import { Curso } from '@/__env/lib/Cursos';
import { isNumber, isArray } from 'util';
import { Resultado } from '@/__env/lib/Cursos/Resultado';
@Component( {
    name: "Componente",
    props: {},
    components: {
        preguntas,
    }
} )
export default class Componente extends Vue
{
    public get Controlador(): ControladorDeCurso { return Model; }
    public get Curso(): Curso { return Model.Curso; }
    public get Resultado(): Resultado { return Model.Resultado; }

    public Intervalo: NodeJS.Timeout = null;
    public Iniciando: boolean = false;
    public Finalizado: boolean = false;
    public Calificacion: number = 0;
    @Watch( 'Calificacion' )
    async onCalificacion()
    {
        if ( this.Resultado && this.Calificacion == this.Resultado.Calificacion.round( 0 ) )
        {
            this.Finalizado = true;
            clearInterval( this.Intervalo );
        }
    }

    async mounted()
    {
        this.Iniciando = true;
        let e = await this.Controlador.FinalizarCurso();
        if ( e )
        {
            await Wait( 1000 );
            this.Iniciando = false;

            if ( this.Resultado.Calificacion > 0 )
            {
                this.Intervalo = setInterval( () =>
                {
                    this.Calificacion++;
                }, this.Resultado.Calificacion > 30 ? 10 : 30 );
            } else
            {
                this.Finalizado = true;
            }


        } else
        {
            this.$EventBus.Notificaciones.Error( 'Ocurrió un error' );
        }


    }
}
